var SortableBox = {
	initializeSortableBox: function(tagName) {
		this.sortTagName = tagName;
		this.sorterBtnDiv = this.el.querySelector('.sorterBtns');
		if (this.sorterBtnDiv != undefined) {
			this.setupSorterBtns();
		}
	},

	setupSorterBtns: function(opacityOnly) {
		const sorterButtons = this.sorterBtnDiv.querySelectorAll(this.sortTagName);
		sorterButtons.forEach(btn => {
			if (this.options.sortOrder == btn.getAttribute('class')) {
				btn.classList.add('selected');
				btn.style.fontWeight = "bold";
			} else {
				btn.classList.remove('selected');
				btn.style.fontWeight = "normal";
			}

			if (!opacityOnly) {
				this.safeObserve(btn, 'click', this.onSorterBtnClick.bind(this));
				this.safeObserve(btn, 'mouseover', this.onSorterBtnOver.bind(this));
				this.safeObserve(btn, 'mouseout', this.onSorterBtnOut.bind(this));
			}
		});
	},

	onSorterBtnClick: function(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		if (this.requestRunning || this.disablePaging)
			return;

		var btn = ev.target.closest(this.sortTagName);
		if (this.options.sortOrder == btn.getAttribute('class').replace(/\s*selected\s*/, ''))
			return;

		this.options.sortOrder = btn.getAttribute('class').replace(/\s*selected\s*/, '');
		this.setupSorterBtns(true);
		this.options.currentPage = 0;
		this.refresh();
	},

	onSorterBtnOver: function(ev) {
		var btn = ev.target.closest(this.sortTagName);
		if (!btn.hover) {
			btn.hover = true;
			//btn.classList.add('selected');
		}
	},

	onSorterBtnOut: function(ev) {
		var btn = ev.target.closest(this.sortTagName);
		btn.hover = false;
		if (this.options.sortOrder == btn.getAttribute('class').replace(/\s*selected\s*/, ''))
			btn.classList.add('selected');
		else
			btn.classList.remove('selected');
	}
};
